import React, { useState, useEffect } from "react";
import { useWatchState } from "@/store";
import { checkResult } from "@/common";
import { BaseService } from "@/service";
import { Modal, Badge, Table } from "antd";

const NAME = "demandPushRecord";

const App = () => {

    const [[modalProps]] = useWatchState(["modal." + NAME])
    const { title = "需求推送详情", show, hide, width = 800, demandId, demandName } = modalProps;

    const [data, setData] = useState([]);

    useEffect(() => {
        if (demandId) getPushRecord(demandId)
    }, [demandId])

    const getPushRecord = xuqiu_id => {
        BaseService.list({
            table: "thtt_push_group_items",
            where: { item_id: xuqiu_id },
            leftJoin: {
                table: "thtt_push_group",
                on: "thtt_push_group.id = thtt_push_group_items.push_group_id",
                columns: ["title AS PGTitle", "title_params AS PGTitleParams"]
            },
            process: {
                name: "orgs",
                key: "push_wechat_ids",
                targetKey: "push_id",
                params: {
                    table: "thtt_push_wechat_orgs",
                    leftJoin: {
                        table: "thtt_organization",
                        on: "thtt_organization.organization_id = thtt_push_wechat_orgs.org_id",
                        columns: ["name AS orgName", "contacts AS orgContacts", "contacts_tel AS orgContactsTel"]
                    },
                }
            }
        }).then(res => {
            if (!checkResult(res)) return;
            setData(res.data.result);
        })
    }

    const columns = [
        {
            title: "机构名称",
            dataIndex: "orgName",
            key: "orgName",
        },
        {
            title: "机构联系人",
            dataIndex: "orgContacts",
            key: "orgContacts",
        },
        {
            title: "机构联系电话",
            dataIndex: "orgContactsTel",
            key: "orgContactsTel",
        },
        {
            title: "推送状态",
            dataIndex: "push_status",
            key: "push_status",
            width: 85,
            render: state => (!state && state !== 0 ? <Badge status="warning" className="nowrap" text="待处理" /> : [
                <Badge color="#2db7f5" className="nowrap" text="预推送" />,
                <Badge status="success" className="nowrap" text="已推送" />,
                <Badge status="default" className="nowrap" text="已取消" />,
                <Badge status="error" className="nowrap" text="推送异常" />,
            ][state])
        },
        {
            title: "推送时间",
            dataIndex: "push_time",
            key: "push_time",
            width: 120,
            render: time => time ? new Date(time * 1000).format("yyyy-MM-dd") : "-"
        },
    ];

    return (
        <Modal
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            onCancel={hide}
            footer={false}
            destroyOnClose={true}
        >
            <div className="child-top-sm">
                <p>
                    <span className="bold dark-title">需求名称：</span>
                    <span className=" dark-second">{demandName}</span>
                </p>

                <p className="bold dark-title">推送记录：</p>

                <div className="child-top-md p-sm-l">
                    {data.map(({ PGTitle, PGTitleParams, orgs = [] }) => (
                        <div>
                            <p className="dark-second p-xs-tb">{PGTitleParams}{PGTitle && ` - ${PGTitle}`}</p>
                            <Table
                                columns={columns}
                                className="full"
                                size="middle"
                                dataSource={orgs}
                                pagination={false}
                            />
                        </div>
                    ))}
                </div>
            </div>

        </Modal>
    );
}

export default App;